import {DommagesTousAccidents, IndemAccidentResponsable, Remorquage, VolIncendie} from '@amo/core/components/questions';
import GoToCoordonnees from './GoToCoordonnees/GoToCoordonnees';

const Besoins = (props) => {
    const { id } = props;

    return (
        <div id={id}>
            <VolIncendie {...props} />
            <DommagesTousAccidents {...props} />
            <Remorquage {...props} />
            <IndemAccidentResponsable {...props} />
            <GoToCoordonnees {...props} />
        </div>
    );
};

export default Besoins;
